import { useState } from "react";
import { Link } from "react-router-dom";
import { useUI } from "@/context/UIContext";

export default function CartDrawer() {
  const { cartOpen, closeCart, items, updateQty, removeItem, subtotal } = useUI();
  const [removing, setRemoving] = useState<number | null>(null);

  const handleRemove = (idx: number) => {
    setRemoving(idx);
    setTimeout(() => {
      removeItem(idx);
      setRemoving(null);
    }, 260);
  };

  return (
    <>
      <div
        onClick={closeCart}
        className={`fixed inset-0 z-[60] bg-black/40 transition-opacity duration-300 ${cartOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`}
        aria-hidden={!cartOpen}
      />
      <aside
        className={`fixed top-0 right-0 z-[70] h-full w-full sm:w-[440px] bg-canvas flex flex-col transition-transform duration-300 ${cartOpen ? "translate-x-0" : "translate-x-full"}`}
        style={{ transitionTimingFunction: "cubic-bezier(0.22,1,0.36,1)" }}
        role="dialog"
        aria-label="Shopping bag"
      >
        <div className="flex items-center justify-between px-6 h-[64px] border-b border-stone">
          <p className="eyebrow">Your Bag ({items.length})</p>
          <button onClick={closeCart} aria-label="Close" className="w-10 h-10 -mr-2 flex items-center justify-center cursor-pointer transition-opacity hover:opacity-65">
            <i className="ri-close-line text-[18px]"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 && (
            <div className="py-24 text-center">
              <p className="text-graphite text-sm">Your bag is empty.</p>
              <button onClick={closeCart} className="mt-6 inline-block border-b border-black text-[12px] tracking-[0.2em] uppercase pb-1 cursor-pointer">
                Continue Shopping
              </button>
            </div>
          )}
          {items.map((it, idx) => (
            <div key={idx} className={`cart-item flex gap-4 py-5 border-b border-stone ${removing === idx ? "removing" : ""}`}>
              <div className="w-20 h-20 bg-stone shrink-0 overflow-hidden">
                <img src={it.product.image} alt={it.product.name} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1">
                <div className="flex justify-between text-sm text-black">
                  <p>{it.product.name}</p>
                  <p>${(it.product.price * it.qty).toLocaleString()}</p>
                </div>
                <p className="mt-1 text-xs text-graphite">{it.variant}</p>
                <div className="mt-3 flex items-center justify-between">
                  <div className="inline-flex items-center border border-black/15">
                    <button onClick={() => updateQty(idx, it.qty - 1)} aria-label="Decrease" className="w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-150 hover:bg-[#F2F2F2]"><i className="ri-subtract-line text-[14px]"></i></button>
                    <span className="w-10 text-center text-[13px]">{it.qty}</span>
                    <button onClick={() => updateQty(idx, it.qty + 1)} aria-label="Increase" className="w-10 h-10 flex items-center justify-center cursor-pointer transition-colors duration-150 hover:bg-[#F2F2F2]"><i className="ri-add-line text-[14px]"></i></button>
                  </div>
                  <button onClick={() => handleRemove(idx)} className="text-xs text-graphite hover:text-black cursor-pointer transition-colors">Remove</button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-stone px-6 py-6">
            <div className="flex justify-between text-sm text-black">
              <span>Subtotal</span>
              <span>${subtotal.toLocaleString()}</span>
            </div>
            <p className="text-xs text-graphite mt-1">Shipping and taxes calculated at checkout.</p>
            <Link
              to="/cart"
              onClick={closeCart}
              className="mt-6 h-12 flex items-center justify-center text-canvas text-[13px] font-medium tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200"
              style={{ backgroundColor: "#1E144D" }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2A2061")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#1E144D")}
            >
              Secure Checkout
            </Link>
            <button onClick={closeCart} className="mt-3 w-full h-11 border border-black/15 text-[13px] font-medium tracking-[0.2em] uppercase whitespace-nowrap cursor-pointer hover:border-black transition-colors duration-200">
              Continue Shopping
            </button>
          </div>
        )}
      </aside>
    </>
  );
}